import Styles from './ChooseContentPlurality.module.scss'

import { Form } from 'components/Wizards/Form/Form'
import { Field } from 'components/Wizards/Field/Field'
import { MultipleFiles } from './MultipleFiles'
import { SingleFile } from './SingleFile'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'almanac-ui/icons'
import { Option } from '../Option/Option'
import { AlignLeft } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { TranscribedTextModal } from '../TranscribedTextModal/TranscribedTextModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  isMulti: boolean
  onChange: (value: boolean) => void
  onContinue: () => void
  goBack: () => void
  isFromDoc?: boolean
  transcribedText?: string
}

export const ChooseContentPlurality = ({
  onChange,
  isMulti,
  onContinue,
  goBack,
  isFromDoc,
  transcribedText = '',
}: Props) => {
  const { openModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  return (
    <Form.Root>
      <Form.Section>
        <Form.SectionContent>
          <Form.Fields className={Styles.container}>
            <Field label="Do you want to turn this into one piece of content or multiple?" isRequired>
              <div className={Styles.optionsContainer}>
                <Option
                  isSelected={isMulti}
                  onChange={() => onChange(true)}
                  icon={<MultipleFiles />}
                  description="Multiple pieces of content in different channels"
                />
                <Option
                  isSelected={!isMulti}
                  onChange={() => onChange(false)}
                  icon={<SingleFile />}
                  description="Turn into a single piece of content"
                />
              </div>
            </Field>
            {transcribedText && (
              <Button
                variant="tertiary"
                frontIcon={AlignLeft}
                onPress={() =>
                  openModal(
                    TranscribedTextModal,
                    {
                      content: transcribedText,
                    },
                    { newStack: true, underlayVariant: 'wizard' },
                  )
                }
              >
                Show Transcribed Text
              </Button>
            )}
          </Form.Fields>
        </Form.SectionContent>
      </Form.Section>
      <Form.Actions isSticky>
        {isFromDoc ? <div /> : <Form.PreviousButton onPress={goBack}>Previous Step</Form.PreviousButton>}
        <Button size="lg" onPress={onContinue} endIcon={ArrowRight} fullWidth={isMobile}>
          Select Content Type{isMulti ? 's' : ''}
        </Button>
      </Form.Actions>
    </Form.Root>
  )
}
